import { OnInit } from '@angular/core';
import { WorkspaceService } from '../services/workspace.service';
import { TokenManager } from '../Globals';
import { LoginService } from '../services/login.service';
import { Globals } from '../objects/Globals';
import { Router } from '@angular/router';
var FaqComponent = /** @class */ (function () {
    function FaqComponent(workspaceService, tokenManager, loginService, globals, router) {
        this.workspaceService = workspaceService;
        this.tokenManager = tokenManager;
        this.loginService = loginService;
        this.globals = globals;
        this.router = router;
    }
    FaqComponent.prototype.ngOnInit = function () {
        this.handleSession();
    };
    FaqComponent.prototype.getFAQ = function () {
        var _this = this;
        this.isBusy = true;
        this.workspaceService.getFAQ().subscribe(function (result) {
            _this.FAQList = JSON.parse(result);
            _this.sortFAQ();
            _this.isBusy = false;
        });
    };
    FaqComponent.prototype.sortFAQ = function () {
        this.FAQList = this.FAQList.sort(function (a, b) {
            if (a.MessageOrder > b.MessageOrder) {
                return 1;
            }
            else if (a.MessageOrder < b.MessageOrder) {
                return -1;
            }
            else {
                return 0;
            }
        });
    };
    FaqComponent.prototype.handleSession = function () {
        var _this = this;
        var sessionCookie = JSON.parse(this.tokenManager.retrieve("BRNSessionKey"));
        var self = this;
        if (sessionCookie) {
            this.loginService.getSession(sessionCookie).subscribe(function (result) {
                if (result) {
                    var checkSessionObject = JSON.parse(result);
                    if (checkSessionObject.SessionObject) {
                        var sessionObject = checkSessionObject.SessionObject;
                        self.globals.Session = sessionObject;
                        self.globals.CardItems = [];
                        _this.loginService.setSession(self.globals.Session);
                        _this.getFAQ();
                    }
                }
            }, function (error) {
                _this.tokenManager.store("BRNSessionKey", null);
            });
        }
        else {
            //this.router.navigate(['/', 'login']);
        }
    };
    return FaqComponent;
}());
export { FaqComponent };
var FrequentlyAskedQuestion = /** @class */ (function () {
    function FrequentlyAskedQuestion() {
    }
    return FrequentlyAskedQuestion;
}());
export { FrequentlyAskedQuestion };
